import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gpv-kunden-filter-gruppen-zuweisung',
  templateUrl: './kunden-filter-gruppen-zuweisung.component.html',
  styleUrls: ['./kunden-filter-gruppen-zuweisung.component.css']
})
export class KundenFilterGruppenZuweisungComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
